import FiltersAlertBase from "components/filters-alert";
import { usePublicClassifierValues } from "hooks/api/system-admin/classifiers/use-public-classifier-values";
import { useDictionary } from "hooks/use-dictionary";
import { useMemo } from "react";
import { ClassifierType } from "types/classifier";
import { PublicSpecialistLicenseAndStampFilters } from "types/specialist-license-and-stamp";

interface FiltersAlertProps {
  filters: PublicSpecialistLicenseAndStampFilters;
}

const FiltersAlert = ({ filters }: FiltersAlertProps) => {
  const dict = useDictionary();
  const { items: qualifications } = usePublicClassifierValues(ClassifierType.SPECIALIST_LICENSE_TYPE);
  const qualificationNames = useMemo(
    () => Object.fromEntries(qualifications.map((qualification) => [qualification.id, qualification.valueName])),
    [qualifications]
  );

  return (
    <FiltersAlertBase
      filters={filters}
      formatters={{
        stampNumber: (value) => `${dict.specialistLicenses.stampNumber} (${value})`,
        firstName: (value) => `${dict.specialistLicenses.firstName} (${value})`,
        lastName: (value) => `${dict.specialistLicenses.lastName} (${value})`,
        professionalQualificationId: (value) => value === null ? "" : `${dict.specialistLicenses.qualification} (${qualificationNames[value] ?? value})`,
        licenseNumber: (value) => `${dict.specialistLicenses.licenseNumber} (${value})`,
        licenseStatus: (value) => value === null ? "" : `${dict.specialistLicenses.licenseStatus} (${dict.specialistUserLicenseStatus[value]})`,
        licenseIssueDateFrom: (value) => `${dict.specialistLicenses.licenseIssueDateFrom} (${value})`,
        licenseIssueDateTo: (value) => `${dict.specialistLicenses.licenseIssueDateTo} (${value})`,
      }}
    />
  );
};

export default FiltersAlert;
